import * as XLSX from "xlsx";


export const validateEmail = (email) => {
    const emailPattern = new RegExp(/^(?:[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}|(?:\[(?:IPv6:[a-fA-F0-9:.]+|(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\]))$/);
    if (!emailPattern.test(email)) return false;

    // Block .test domains
    const domain = email.split('@')[1];
    if (domain.toLowerCase().endsWith('.test')) {
        return false;
    }

    return true;
}


export const downloadExcelSampleFile = (data, fileName = 'sample-file.xlsx') => {
    const ws = XLSX.utils.json_to_sheet(data);

    // Force SIMNumber as text
    const range = XLSX.utils.decode_range(ws["!ref"]);
    for (let row = range.s.r + 1; row <= range.e.r; row++) {
        const cell = XLSX.utils.encode_cell({ r: row, c: 0 });
        if (ws[cell]) ws[cell].t = "s";
    }

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sample");

    XLSX.writeFile(wb, fileName);
};


export const twoDigitDecimal = (number) => {
    const value = parseFloat(number);
    return Number.isNaN(value) ? "0.00" : value.toFixed(2);
};